<template>
  <div class="alert_card">
    <template v-if="!dataReady">
      <div class="text-center">
        <f-icon icon="spinner" pulse></f-icon>
      </div>
    </template>
    <!-- <b-collapse id="cl-alert" v-model="dataReady"> -->
    <template v-if="dataReady">
      <h4 v-if="items.length > 0" class="alert-heading"><b>ประกาศ</b> <f-icon icon="exclamation-triangle" :style="{ color: '#b30000' }"></f-icon> <b-badge @click="visible = !visible">({{ visible ? 'ซ่อน' : 'แสดง' }}ประกาศ)</b-badge></h4>
      <b-collapse id="collapse-alert" v-model="visible">
        <b-alert show :variant="item.color" :class="'border-1r alert-dismissible border-'+item.color" v-for="item in items" :key="item.id">
          <f-icon v-if="item.icon" :icon="item.icon"></f-icon>
          <span v-html="item.announceDetail.replaceAll('\n', '<br>')"></span>
        </b-alert>
      </b-collapse>

      <!-- <b-alert show variant="warning" class="border-1r border-warning">
        เนื่องจากการแพร่ระบาดของ COVID-19 ทำให้ด่านมีการตรวจเข้มขึ้นและเกิดน้ำท่วมทำให้ขนส่งล่าช้าจากกำหนดการเดิม 2-3 วัน 
      </b-alert>

      <b-alert show variant="warning" class="border-1r border-warning">
        ทางบริษัทขอไม่รับขนส่งชุดตรวจ (Rapid test) ทุกชนิด หากด่านตรวจพบค่าปรับทั้งหมดจะตกเป็นของผู้ที่นำเข้า แต่อุปกรณ์การแพทย์อย่างอื่นยังสามารถนำเข้าได้ปกติ
      </b-alert>

      <b-alert show variant="warning" class="border-1r border-warning" dismissible>
        งดรับสินค้าที่โกดังจนกว่าจะมีกำหนดการใหม่ <b class="mb-0">ขออภัยในความไม่สะดวก</b>
      </b-alert> -->

      <hr>
    </template>
    <!-- </b-collapse> -->
  </div>
</template>

<script>
import axios from "axios"; // api
export default {
  name: "AlertCard",
  mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.userData = this.getDataStorageUser()
    this.getDataAnnounce()
  },
  data() {
    return {
      msg: "แจ้งเตือนเท่านั้น",
      dataReady: false,
      visible: true,
      items: [],
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
    }
  },
  methods: {
    showAlert () {
      // Use sweetalert2
      this.$swal("แจ้งเตือนเท่านั้น!!!");
    },
    getDataAnnounce() {
      this.dataReady = false
      axios
        .get(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Announce/Announce_list?userName=" +
          this.userData.userName,
          {
            headers: this.getHeaderAPI('Announce_list', this.userData.userName)
          }
        )
        .then((response) => {
          let rs = response.data
          if (rs.status === true){
            // console.log('getDataAnnounce', rs)
            this.items = rs.data
            this.dataReady = true;
          } else {
            this.$swal("ผิดพลาด","ไม่สามารถดึงข้อมูลประกาศได้","error")
            this.dataReady = true;
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true;
          // this.errored = true
        });
    },
    formatDate (strDate) {
      if (strDate) {
        var dtDate = strDate.split(' ')[0]
        var strDateShort = dtDate.split('-')[2] + '/' + dtDate.split('-')[1] + '/' + dtDate.split('-')[0]
        return strDateShort
      } else {
        return ''
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Alert.vue